import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import Header from "../components/Header";
import IconsBar from "../components/IconsBar/IconsBar";
import News from "../components/News/News";
import { AuthContext } from "../contexts/Auth/AuthContext";
import styled from "styled-components";

const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #1e958c 0%, #0b4f6c 40%, #f5f7fb 100%);
`;

const Home = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Professores são redirecionados automaticamente para o planejamento
    if (user && user.level === "teacher") {
      navigate("/autentico/planning", { replace: true });
    }
  }, [user, navigate]);

  // Se for professor, não renderiza nada (está sendo redirecionado)
  if (user && user.level === "teacher") {
    return null;
  }

  return (
    <Container>
      <Header />
      <IconsBar />
      <News />
    </Container>
  );
};

export default Home;
